import type { ReactNode } from 'react';

import { Countdown } from '@ui/uikit/components/common/Countdown';

export interface ValidationCountdownResult {
  description: string;
  value: ReactNode;
}

export interface GetValidationCountdownProps {
  startDate?: string;
  endDate?: string;
  formattedEndDate?: string;
}

export const getValidationCountdown = ({
  startDate,
  endDate,
  formattedEndDate,
}: GetValidationCountdownProps): ValidationCountdownResult | null => {
  const start = startDate ? new Date(startDate) : null;
  const end = endDate ? new Date(endDate) : null;

  const now = Date.now();

  if (!start && !end) {
    return null;
  }

  if (start && now < start.getTime()) {
    return { description: 'Starts in', value: <Countdown date={start} /> };
  }

  if (end && now < end.getTime()) {
    return { description: 'Ends in', value: <Countdown date={end} /> };
  }

  if (end) {
    return {
      description: 'Validated',
      value: formattedEndDate,
    };
  }

  return null;
};
